import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/auth';

export const ProtectedRoute = () => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) return <Navigate to="/" />;

  return <Outlet />;
};